import React from 'react'

import {
	NumberField,
	PrimaryButton,
	SecondaryButton,
	ButtonsBlock,
} from '../../Ui'
import Modal from '../../common/components/Modal'

const DeleteModal = ({ isOpen, locking, iterations, onChange, onSubmit, onClose }) =>
	<Modal
		isOpen={isOpen}
		mask="light"
		closeOnClickOutside
		closeOnEsc
		onClose={onClose}>
		<div className="bg-primary border-top border-bottom a-slide">
			<header className="px-1 pt-1 text-center">Combien de fois voulez-vous dupliquer l&#39;ouverture "{locking.name}" ?</header>
			<div className="u-flex u-flex--justify-center p-1 text-center">
				<div style={{width: "50px"}}>
					<NumberField
						value={iterations}
						min={1}
						max={10}
						onChange={onChange} />
				</div>
				<span>fois (max. 10)</span>
			</div>
			<ButtonsBlock>
				<SecondaryButton
					onClick={onClose}>

					Annuler
				</SecondaryButton>
				<PrimaryButton
					onClick={onSubmit}>

					Dupliquer
				</PrimaryButton>
			</ButtonsBlock>
		</div>
	</Modal>


export default DeleteModal;



// WEBPACK FOOTER //
// ./src/js/plan/lockings/DuplicateModal.js